import React from 'react';
import withIcon from '../utilities/withIcon';

const IconEmail = () => {
  return (
    <g>
      <path d="m1.05 2 13.901.017c.541 0 .986.41 1.043.936l.006.114v9.883c0 .541-.41.987-.936 1.044L14.95 14H1.05a1.05 1.05 0 0 1-1.044-.936L0 12.95v-9.9c0-.54.41-.986.936-1.043L1.05 2zM14.5 4.346 8.463 9.09a.75.75 0 0 1-.832.063l-.094-.063L1.5 4.346V12.5h13V4.346zM2.854 3.502 8 7.546l5.131-4.033-10.277-.01z" />
    </g>
  );
};

export default withIcon(IconEmail);
